import React from "react";

import { TimezoneContext } from "../context/timezone-context";

function DateInUserTimezone({ date, showTime = true}) {
  const { timezone } = React.useContext(TimezoneContext);
  return (
    <>
      {showTime ? (
        <>
          {timezone
            ? new Date(date).toLocaleString("en-US", {
                timeZone: timezone,
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })
            : new Date(date).toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}
        </>
      ) : (
        <>
          {timezone
            ? new Date(date).toLocaleString("en-US", {
                timeZone: timezone,
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            : new Date(date).toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
        </>
      )}
    </>
  );
}

export default DateInUserTimezone;
